let IdNamePair = require('./IdNamePair');

module.exports = class Type extends IdNamePair {};
